<div class="hero-event-list-container">
<app-hero-event-list-filters
  [filters]="filters"
  [eventCategoryOptions]="eventCategoryOptions"
  (filtersUpdated)="updateFilters($event)"

  />
<app-hero-event-list-table
  [dataArr]="heroEvents"
  [tableFilters]="filters.tableFilters"
  (tableFiltersUpdated)="updateTableFilters($event)"
  />
</div>
